/**
 * Admin API — fechamento/apuração do cliente (EUN).
 */
import { api } from "@/lib/api";

interface Page<T> {
  items: T[];
  total: number;
  page: number;
  size: number;
}

export interface ClosingItem {
  id: string;
  job_id: string;
  job_code: string;
  description: string;
  amount: string;
  scheduled_at: string | null;
  recognized: boolean;
  dispute_reason: string | null;
}

export interface Closing {
  id: string;
  client_id: string;
  client_name: string | null;
  contract_name?: string | null;
  year: number;
  month: number;
  status: string;
  gross_total: string;
  recognized_total: string;
  disputed_total: string;
  item_count: number;
  sent_at: string | null;
  closed_at: string | null;
  finalized_at: string | null;
  closed_by_name?: string | null;
  eun_notes?: string | null;
  created_at: string;
  items?: ClosingItem[];
}

export const closingsApi = {
  list: async (params: Record<string, unknown> = {}): Promise<Page<Closing>> => {
    const { data } = await api.get<Page<Closing>>("/v1/closings", { params });
    return data;
  },
  get: async (id: string): Promise<Closing> => {
    const { data } = await api.get<Closing>(`/v1/closings/${id}`);
    return data;
  },
  generate: async (year: number, month: number): Promise<Record<string, number>> => {
    const { data } = await api.post("/v1/closings/generate", { year, month });
    return data;
  },
  send: async (id: string): Promise<Closing> => {
    const { data } = await api.post<Closing>(`/v1/closings/${id}/send`);
    return data;
  },
  link: async (id: string): Promise<{ url: string }> => {
    const { data } = await api.get<{ url: string }>(`/v1/closings/${id}/link`);
    return data;
  },
  reconcile: async (
    id: string,
    recognized_item_ids: string[],
    notes?: string,
  ): Promise<Closing> => {
    const { data } = await api.post<Closing>(`/v1/closings/${id}/reconcile`, {
      recognized_item_ids,
      notes,
    });
    return data;
  },
  finalize: async (id: string, notes?: string): Promise<Closing> => {
    const { data } = await api.post<Closing>(`/v1/closings/${id}/finalize`, { notes });
    return data;
  },
};

export const CLOSING_STATUS_LABEL: Record<string, string> = {
  draft: "Rascunho",
  sent: "Enviado",
  under_review: "Em conferência",
  closed_by_client: "Fechado pelo cliente",
  adjusted: "Ajustado",
  finalized: "Finalizado",
  cancelled: "Cancelado",
};
